import React, {useCallback, useEffect, useState} from 'react';
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';
import useUAlert from "ubs-framework/v2/UAlert";
import DropDownFilter from "../../components/dropdown-filter";
// import InputFilter from "../../components/input-filter";
import * as Icon from "ubs-icons";

import {sendData} from "../../../../../store/actions";
import {useSelector} from "react-redux";
import UPopup from "ubs-framework/v2/UPopup";
import InputFilter from "../../components/input-filter";
import {COLOR, CONSTANT, FORMAT} from "ubs-framework/v2/common/constant";
import {isMobileDevice} from "ubs-framework/v2/common/function";
import DatePickerFilter from "../../components/datepicker-filter";
import UDateFormatter from "ubs-framework/v2/Udate-formatter";
import {getKeyValue, getLabelValue} from "ubs-framework/v2/common/function";
import {EXPECTED_CTC_TYPE} from "../../../../../common/constant";
import { useFieldLabel } from 'ubs-framework/v2/hooks/useCustomFieldConfig';
import { PROFILE_SECTION } from 'ubs-framework/v2/common/constant';

const VerifyTableData = React.memo((props) => {
    const alert = useUAlert();
    const _A_LT_KV = useSelector(e => getKeyValue(e?.hrms?.branchList));
    const getLabel = useFieldLabel();

    const _SL_LV = useSelector(e => getLabelValue(e?.hrms?.sourceList));
    const _RT_CL = useSelector(e => getLabelValue(e?.ats?.reasonToChangeList));
    const _A_LT_LV = useSelector(e => getLabelValue(e?.hrms?.branchList));

    const [errorList, setErrorList] = useState(props?.globalErrorList)
    const handle = {
        inputChange: (e, name, index) => {
            const data = JSON.parse(JSON.stringify(errorList))
            if (e !== '') {
                data[index][name] = e
                data[index].success = true
                if (data[index]?.error) {
                    /** success key for remove success data from listing */
                    delete data[index]?.error[name]
                }
            } else {
                data[index][name] = props?.originalErrorList[index]?.error && props?.originalErrorList[index]?.error[name] || data[index][name]
            }
            setErrorList(data)
            props?.FinalData(data)
        },
        selectChange: (e, name, index) => {
            const data = JSON.parse(JSON.stringify(errorList))
            if (e !== '') {
                data[index][name] = e
                data[index].success = true
                if (data[index]?.error) {
                    /** success key for remove success data from listing */
                    delete data[index]?.error[name]
                }
            } else {
                data[index][name] = props?.originalErrorList[index]?.error && props?.originalErrorList[index]?.error[name] || data[index][name]
            }
            setErrorList(data)
            props?.FinalData(data)
        },
        dateChange: (e, name, index) => {
            const data = JSON.parse(JSON.stringify(errorList))
            data[index][name] = new Date(e).getTime()
            data[index].success = true
            if (data[index]?.error) {
                delete data[index]?.error[name]
            }
            setErrorList(data)
            props?.FinalData(data)
        },
        approveData: (e, i) => {
            alert.show({
                title: `Upload Data`,
                icon: <Icon.Upload fill={COLOR.u_green} size={30}/>,
                type: 'success',
                description: `Are you sure you want to Upload data?`,
                submit: 'Yes',
                onSubmit: () => {
                    const eData = JSON.parse(JSON.stringify(errorList))
                    errorList.splice(i, 1)
                    setErrorList(errorList)
                    props?.setGlobalErrorList(errorList)
                    props?.FinalData(errorList)

                    let data = {
                        randomString: props?.randomString,
                        step: 2,
                        list: [e]
                    }
                    data.employeeIds = [e?.employeeId]
                    sendData('ats|candidate|insert', data);
                }
            });
        },
        removeData: (e, i) => {
            alert.show({
                title: `Delete Data`,
                icon: <span className="u_icon u_red-bgicon u_m-auto"><Icon.Delete fill={COLOR.u_red} size={30}/></span>,
                description: `Are you sure you want to Remove Data?`,
                submit: 'Yes',
                onSubmit: () => {
                    const data = JSON.parse(JSON.stringify(errorList))
                    data.splice(i, 1)
                    setErrorList(data)
                    props?.FinalData(data)
                    props?.setGlobalErrorList(data)
                }
            });
        },
    }

    useEffect(() => {
        /** for update ERROR data */
        setErrorList(props?.globalErrorList)
        props?.FinalData(props?.globalErrorList)
    }, [props?.globalErrorList])

    return (
        <React.Fragment>
            <UCustomScrollBar className="u_import-scroll">
                <div className="u_table-resource u_table-resource-nowrap u_table-resource-hover u_table-resource-no-sticky u_text-left">
                    <table>
                        <thead className="u_table-resource-header">
                        <tr>
                            <th>Action</th>
                            <th>Error</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'firstName', 'First Name')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'lastName', 'Last Name')}</th>
                            <th>{getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'dob', 'Date of Birth')}</th>
                            <th>Contact Number</th>
                            <th>Job</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'gender', 'Gender')}</th>
                            <th>{getLabel(PROFILE_SECTION.jobInfo, 'location', 'Location')}</th>
                            <th>{getLabel(PROFILE_SECTION.previousEmployee, 'workExperience', 'Total Experience')}</th>
                            <th>Current CTC</th>
                            <th>Expected CTC Type</th>
                            <th>Expected CTC</th>
                            <th>Expected CTC Range From</th>
                            <th>Expected CTC Range To</th>
                            <th>{getLabel(PROFILE_SECTION.compensationInfo, 'noticePeriod', 'Notice Period (In Days)')}</th>
                            <th>Reason to Change</th>
                            <th>{getLabel(PROFILE_SECTION.contactSocial, 'skype', 'Skype ID')}</th>
                            <th>{getLabel(PROFILE_SECTION.contactSocial, 'linkedIn', 'LinkedIn URL')}</th>
                            <th>Source</th>
                            <th>Portfolio Links</th>
                        </tr>
                        </thead>

                        <tbody>
                        {errorList?.map((data, i) => {
                            return (
                                <tr key={i}>
                                    <td style={{backgroundColor: '#fff'}}>
                                        <div className="u_flex u_align-center">
                                            <UPopup
                                                params={{className: "u_tooltip", disabled: isMobileDevice()}}
                                                desc={<span>Upload Data</span>}
                                            >
                                                <span className={`u_icon-rollover u_cp ${data?.ERROR ? 'u_btn-disabled-' : ''}`}
                                                      onClick={() => handle.approveData(data, i)}><Icon.Upload fill={COLOR.u_blue} size={18}/>
                                                </span>
                                            </UPopup>

                                            <UPopup
                                                params={{className: "u_tooltip", disabled: isMobileDevice()}}
                                                desc={<span>Delete Data</span>}
                                            >
                                                <span className="u_icon-rollover u_cp u_ml-5" onClick={() => handle.removeData(data, i)}>
                                                    <Icon.Delete fill={COLOR.u_blue} size={16}/>
                                                </span>
                                            </UPopup>
                                        </div>

                                    </td>
                                    <td style={{backgroundColor: data?.ERROR ? '#ffe9e7' : '#fff'}}>{data?.ERROR || '-'}</td>
                                    <td style={{backgroundColor: data?.error?.['candidateId'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')}`}
                                            onChange={(e) => handle.inputChange(e, 'candidateId', i)}
                                            errorTitle={data?.error?.['candidateId'] || data?.['candidateId']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['firstName'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.basicInfo, 'firstName', 'First Name')}`}
                                            onChange={(e) => handle.inputChange(e, 'firstName', i)}
                                            errorTitle={data?.error?.['firstName'] || data?.['firstName']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['lastName'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.basicInfo, 'lastName', 'Last Name')}`}
                                            onChange={(e) => handle.inputChange(e, 'lastName', i)}
                                            errorTitle={data?.error?.['lastName'] || data?.['lastName']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['email'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter Valid ${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')}`}
                                            onChange={(e) => handle.inputChange(e, 'email', i)}
                                            errorTitle={data?.error?.['email'] || data?.['email']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['dob'] ? '#ffe9e7' : '#fff'}}>
                                        <DatePickerFilter
                                            placeholder="Select Date"
                                            onChange={(e) => handle.dateChange(e, 'dob', i)}
                                            errorTitle={data?.error?.dob || <UDateFormatter date={data?.dob} format={FORMAT.TICKET_DATE}/>}
                                            type="dob"
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['contactNo'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter Contact Number"
                                            onChange={(e) => handle.inputChange(e, 'contactNo', i)}
                                            errorTitle={data?.error?.['contactNo'] || data?.['contactNo']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['job'] ? '#ffe9e7' : '#fff'}}>
                                        <DropDownFilter
                                            placeholder={`Select ${getLabel(PROFILE_SECTION.jobInfo, 'jobTitle', 'Job Title')}`}
                                            option={props?.jobList}
                                            errorTitle={data?.job || props?.jobList?.find(_ => _?.value === data?.jobId)}
                                            iconType="job"
                                            type="job"
                                            onChange={(e) => handle.selectChange(e, 'job', i)}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['gender'] ? '#ffe9e7' : '#fff'}}>
                                        <DropDownFilter
                                            placeholder={`Select ${getLabel(PROFILE_SECTION.basicInfo, 'gender', 'Gender')}`}
                                            option={CONSTANT.GENDER_LIST}
                                            errorTitle={data?.error?.gender || CONSTANT.GENDER_LIST?.find(_ => _?.value === data?.gender)?.value}
                                            iconType="gender"
                                            type="gender"
                                            onChange={(e) => handle.selectChange(e, 'gender', i)}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['location'] ? '#ffe9e7' : '#fff'}}>
                                        <DropDownFilter
                                            placeholder={`Select ${getLabel(PROFILE_SECTION.jobInfo, 'location', 'Location')}`}
                                            option={_A_LT_LV}
                                            errorTitle={data?.error?.location || _A_LT_KV[data?.locationId]}
                                            iconType="location"
                                            type="location"
                                            onChange={(e) => handle.selectChange(e, 'locationId', i)}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['experience'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.previousEmployee, 'workExperience', 'Total Experience')}`}
                                            onChange={(e) => handle.inputChange(e, 'experience', i)}
                                            errorTitle={data?.error?.['experience'] || data?.['experience']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['currentCtc'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter Current CTC"
                                            onChange={(e) => handle.inputChange(e, 'currentCtc', i)}
                                            errorTitle={data?.error?.['currentCtc'] || data?.['currentCtc']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['expectedCtcType'] ? '#ffe9e7' : '#fff'}}>
                                        <DropDownFilter
                                            placeholder="Select Expected CTC Type"
                                            option={EXPECTED_CTC_TYPE}
                                            errorTitle={data?.error?.expectedCtcType || EXPECTED_CTC_TYPE?.find(_ => _?.value === data?.expectedCtcType)?.label}
                                            iconType="expectedCtcType"
                                            type="expectedCtcType"
                                            onChange={(e) => handle.selectChange(e, 'expectedCtcType', i)}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['expectedCtc'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter Expected CTC"
                                            onChange={(e) => handle.inputChange(e, 'expectedCtc', i)}
                                            errorTitle={data?.error?.['expectedCtc'] || data?.['expectedCtc']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['expectedCtcFrom'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter Expected CTC Range"
                                            onChange={(e) => handle.inputChange(e, 'expectedCtcFrom', i)}
                                            errorTitle={data?.error?.['expectedCtcFrom']?.from || data?.['expectedCtcFrom']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['expectedCtcTo'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter Expected CTC To"
                                            onChange={(e) => handle.inputChange(e, 'expectedCtcTo', i)}
                                            errorTitle={data?.error?.['expectedCtcTo']?.from || data?.['expectedCtcTo']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['noticePeriod'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.compensationInfo, 'noticePeriod', 'Notice Period (In Days)')}`}
                                            onChange={(e) => handle.inputChange(e, 'noticePeriod', i)}
                                            errorTitle={data?.error?.['noticePeriod'] || data?.['noticePeriod']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['reasonToChange'] ? '#ffe9e7' : '#fff'}}>
                                        <DropDownFilter
                                            placeholder="Enter Reason to Change"
                                            option={_RT_CL}
                                            errorTitle={data?.error?.reasonToChange || _RT_CL?.find(_ => _?.value === data?.reasonToChange)?.label}
                                            type="reasonToChange"
                                            onChange={(e) => handle.selectChange(e, 'reasonToChange', i)}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['skypeId'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.contactSocial, 'skype', 'Skype ID')}`}
                                            onChange={(e) => handle.inputChange(e, 'skypeId', i)}
                                            errorTitle={data?.error?.['skypeId'] || data?.['skypeId']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['linkedIn'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter linkedIn URL"
                                            onChange={(e) => handle.inputChange(e, 'linkedIn', i)}
                                            errorTitle={data?.error?.['linkedIn'] || data?.['linkedIn']}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['source'] ? '#ffe9e7' : '#fff'}}>
                                        <DropDownFilter
                                            placeholder="Select Source Type"
                                            option={_SL_LV}
                                            errorTitle={data?.error?.source || _SL_LV?.find(_ => _?.name === data?.source)?.label}
                                            iconType="Employee Exit Type"
                                            type="source"
                                            onChange={(e) => handle.selectChange(e, 'source', i)}
                                        />
                                    </td>
                                    <td style={{backgroundColor: data?.error?.['portfolioLinks'] ? '#ffe9e7' : '#fff'}}>
                                        <InputFilter
                                            placeholder="Enter Portfolio Links"
                                            onChange={(e) => handle.inputChange(e, 'portfolioLinks', i)}
                                            errorTitle={data?.error?.['portfolioLinks'] || data?.['portfolioLinks']}
                                        />
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                    {errorList?.length === 0 && <UNoDataFound width={300} image="/images/no-data-found.svg" message="No data to display"/>}
                </div>
            </UCustomScrollBar>
        </React.Fragment>
    );
});

export default VerifyTableData;
